/// #if PLATFORM === 'xd'
<template>
  <div class="pageSettingsAccountSwitch">
    Switching...
  </div>
</template>
/// #else
<template>
  <div :class="$style.container">
    Switching...
  </div>
</template>
/// #endif

<script>
import request from '@/lib/axios'
export default {
  async created () {
    if (this.$route.params.type === 'team') {
      await request({
        route: 'switchTeam',
        method: 'post',
        params: {
          team: this.$route.params.uuid
        }
      })
    } else {
      await request({
        route: 'switchUser',
        method: 'post'
      })
    }

    // window.location.reload()
    // Clear Current User Data
    // this.$store.commit('user/setNotLoggedIn')
    // Then Fetch Again Auth
    await this.$store.dispatch('user/fetch')

    // eslint-disable-next-line
/// #if PLATFORM === 'xd'
    this.$router.push({
      name: 'icons-slug'
    })
    // eslint-disable-next-line
/// #else
    // Set the current Page
    this.$router.replace({
      name: 'settings-account'
    })
    // eslint-disable-next-line
/// #endif
  }
}
</script>

/// #if PLATFORM !== 'xd'
<style lang="scss" module>
.container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba($black, 0.7);
  color: $white;
  padding: 50px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: $zindex-popover;
}
</style>
/// #endif
